import { useQuery } from "@tanstack/react-query";

import { listSchedules } from "@/adapters/api";
import {
	toConstructionSummary,
	toScheduleNode,
	toScheduleSpan,
} from "../utils/map.ts";

export function useSchedules(constructionId: string | undefined) {
	return useQuery({
		queryKey: ["schedules", constructionId],
		queryFn: async () => {
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			const response = await listSchedules(constructionId!);
			return {
				nodes: response.items.map(toScheduleNode),
				span: toScheduleSpan(response.span),
				construction: toConstructionSummary(response.construction),
			};
		},
		enabled: !!constructionId,
		staleTime: 30_000,
	});
}
